import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider } from 'react-admin';
import { Chip } from 'shared/mui/Chips';
import { Stack } from 'shared/mui/Stack/Stack';
import { FunctionField, LinkChipField } from 'shared/react-admin/Fields';
import { Company } from 'types/embedded/company';
import { Limit } from 'types/embedded/limit';

export const LimitsShowChipFields: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
      <FunctionField
        render={(record: Company) => <Chip label={`ID: ${record?.originId}`} size="small" />}
      />
      <FunctionField
        render={({ gateway }: Limit) => (
          <RecordContextProvider value={gateway}>
            <LinkChipField label={translate('app.table.gateway')} resource="gateways" />
          </RecordContextProvider>
        )}
      />
      <FunctionField
        render={({ merchant }: Limit) => (
          <RecordContextProvider value={merchant || {}}>
            <LinkChipField label={translate('app.table.merchant')} resource="merchants" />
          </RecordContextProvider>
        )}
      />
    </Stack>
  );
};
